import {uploadRequest} from "@/lib/api_client.ts";

interface FormSubmissionProps {
  name?: string;
  email: string;
  subject: string;
  scope?: string;
  severity?: string;
  vulnerability?: string;
  known_cve?: string;
  description: string;
  attachments?: File[];
}

interface FormSubmissionCreateProps {
  form_id: string;
  form_submission: FormSubmissionProps;
  token: string;
}

export class FormSubmission implements FormSubmissionProps {
  name: string;
  email: string;
  subject: string;
  scope: string;
  severity: string;
  vulnerability: string;
  known_cve: string;
  description: string;
  attachments: File[];

  constructor(data: FormSubmissionProps) {
    this.name = data.name ?? "";
    this.email = data.email;
    this.subject = data.subject;
    this.scope = data.scope ?? "";
    this.severity = data.severity ?? "";
    this.vulnerability = data.vulnerability ?? "";
    this.known_cve = data.known_cve ?? "";
    this.description = data.description;
    this.attachments = data.attachments ?? [];
  }

  static async create({form_id, form_submission, token}: FormSubmissionCreateProps): Promise<void> {
    const formData = new FormData();
    formData.append("name", form_submission.name ?? "");
    formData.append("email", form_submission.email);
    formData.append("subject", form_submission.subject);
    formData.append("scope", form_submission.scope ?? "");
    formData.append("severity", form_submission.severity ?? "");
    formData.append("vulnerability", form_submission.vulnerability ?? "");
    formData.append("known_cve", form_submission.known_cve ?? "");
    formData.append("description", form_submission.description);
    formData.append("token", token);
    form_submission.attachments?.forEach((file, index) => {
      formData.append(`attachments[${index}]`, file);
    });

    return uploadRequest(`/forms/${form_id}/form`, formData);
  }
}
